import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Footer = () => (
  <footer className="footer mt-auto py-3 bg-light" style={{ color: '#000' }}>
    <Container fluid={true}>
      <Row>
        <Col>
          Created with <span style={{ color: '#037ee3' }}>&hearts;</span> by <a href="https://kontentino.com" style={{ color: '#037ee3' }} target="_blank" rel="noopener noreferrer">Kontentino</a> developers!
        </Col>
      </Row>
    </Container>
  </footer>
);

export default React.memo(Footer);
